import React from "react";
import "./age.css";
import { connect } from "react-redux";
import { setAge } from "../../../Redux/action";
import { Link } from "react-router-dom";
import ProfileNavbar from "../../../components/Navbar/ProfileNavbar";
import Footer from "../../../components/Footer/Footer";

const Age = ({ state, setAge }) => {
  return (
    <>
    <ProfileNavbar />
    <div className="age">
      <h1>Please take time to answer these Questions.</h1>
      <div className="select">
        <h3>How old are you?</h3>
        <input
          type="number"
          placeholder="Enter your age"
          min="1"
          onChange={(e) => setAge(e.target.value)}
        />
        <Link to="/dash">
          <button style={{ margin: 10 }} className="continue-btn">
            Done
          </button>
        </Link>
      </div>
    </div>
    <Footer />
    </>
  );
};

const mapDispatchToProps = { setAge };
const mapStateToProps = (state) => {
  return { state };
};

export default connect(mapStateToProps, mapDispatchToProps)(Age);
